import { render, staticRenderFns } from "./ProcedureModelEdit.vue?vue&type=template&id=63a92402&"
import script from "./ProcedureModelEdit.vue?vue&type=script&lang=js&"
export * from "./ProcedureModelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports